// src/views/LeaderboardView.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { LeaderboardTable } from '@/components/leaderboard/LeaderboardTable';
import { TopPerformers } from '@/components/leaderboard/TopPerformers';
import { UserRankCard } from '@/components/leaderboard/UserRankCard';
import { useAuth } from '@/contexts/AuthContext';
import { useLeaderboard } from '@/hooks/useLeaderboard';
import { useTestingData } from '@/hooks/useTestingData';
import { Trophy } from 'lucide-react';

export const LeaderboardView: React.FC = () => {
  const { user } = useAuth();
  const { leaderboard, loading } = useLeaderboard();
  const { stats } = useTestingData(user?.uid);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <div className="text-6xl mb-4 animate-pulse">🏆</div>
          <p className="text-muted-foreground">Loading leaderboard...</p>
        </div>
      </div>
    );
  }

  const userRank = leaderboard.findIndex((u) => u.userId === user?.uid) + 1;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-6"
    >
      <div>
        <h1 className="text-4xl font-bold mb-2 flex items-center gap-3">
          <Trophy className="w-10 h-10 text-yellow-500" />
          Leaderboard
        </h1>
        <p className="text-muted-foreground">
          See how you rank against your teammates
        </p>
      </div>

      {stats && userRank > 0 && (
        <UserRankCard userStats={stats} rank={userRank} />
      )}

      <TopPerformers topThree={leaderboard.slice(0, 3)} />

      <LeaderboardTable users={leaderboard} currentUserId={user?.uid} />
    </motion.div>
  );
};

